import { lazy } from "react";
import { RouteConfig } from "../../types/RouteConfig";

export const dashboardPageRoute: RouteConfig<'with-page'> = {
    name: 'Dashboard',
    path: '/dashboard/home',
    context: 'member',
    icon: 'mdi mdi-home-variant-outline',
    page: lazy(() => import('.')),
    flags: ['member-route', 'member-renew']
}